export default __webpack_public_path__ + "static/media/elevate-swarovski-poster-4.d5b7273b.jpg";